<template>
  <div class="container text-center">
    <h2 class="customers-title-hs321">Наиболее значимые проекты</h2>
    <div class="row">
      <div class="col-lg-4"  v-for='customer in customers' >
        <div class="card">
          <a :href='customer.href' target="_blank">
            <img class="card-img-top" :src='customer.img' :alt='customer.title'>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Customers',
  data () {
    return {
      msg: '',
      customers: [
        {title: 'hardsoft321 открытие банк', href: 'http://open.ru', img: require('@/assets/img/customers/open.png')},
        {title: 'hardsoft321 отп банк', href: 'https://www.otpbank.ru/', img: require('@/assets/img/customers/otp.jpg')},
        {title: 'hardsoft321 омскводоканал', href: 'http://lab321.ru/waterman/', img: require('@/assets/img/customers/omskvodokanal.png')}
      ]
    }
  }
}
</script>

<style scoped>
  /*.customers-title-hs321 {
    margin-bottom: 30px;
  }*/
  .card {
    border: 1px solid rgba(0,0,0,0);
  }
  .card:hover {
    border: 1px solid rgba(0,0,0,.125);
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/Customers.vue